import React, { useCallback } from "react";

function getOnlineStatus() {
  return typeof navigator !== "undefined" &&
    typeof navigator.onLine === "boolean"
    ? navigator.onLine
    : true;
}

function useOnlineStatus() {
  const [isOnline, setIsOnline] = React.useState(getOnlineStatus());

  const goOnline = useCallback(() => {
    setIsOnline(true);
  }, []);

  const goOffline = useCallback(() => {
    setIsOnline(false);
  }, []);

  React.useEffect(() => {
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, [goOffline, goOnline]);

  return { isOnline };
}

export default useOnlineStatus;
